import { useMutation } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useAssignReviewerToDocument() {
  return useMutation({
    ...apiClient.assignReviewerToDocumentDocumentsKeyReviewerPostMutation(),
  })
}
